import {
  API_HOST,
  API_IMG_HOST
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import VueAxios from 'vue-axios'
const axiosJava = axios.create({
  baseURL: API_HOST
})
axiosJava.defaults.timeout = 1000 * 15
axiosJava.defaults.headers.authKey = Lockr.get('authKey')
axiosJava.defaults.headers.sessionId = Lockr.get('sessionId')
axiosJava.defaults.headers['Content-Type'] = 'application/json'

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}
// 返回处理
axiosJava.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code === -1) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    Lockr.rm('firstRoutePath')
    // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101) {
    // _g.toastMsg('error', response.data.error)
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 组织机构列表
export function getListTree (data) {
  let url = 'sw-admin-api/department/listTree'
  return axiosJava.get(url, {
    params: data
  })
}

